'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getGAId = exports.actReport = exports.regReport = exports.addThirdAnalysisCode = exports.monitorReport = exports.log = exports.initDedog = exports.upLoadStat = exports.initReport = undefined;

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Report 业务上报内容（包括 点击事件上报，前端上报）
 * @module Report
 * @author cynthia
 */

var Stat = require('@futuweb/tool-stat');
var BASE = require('@futuweb/tool-base');
var Env = require('@futuweb/tool-browser/es5/env');
var key = '';
var loadPageTime = Date.now() / 1000 >> 0 + '';

exports.initReport = initReport;
exports.upLoadStat = upLoadStat;
exports.initDedog = initDedog;
exports.log = log;
exports.monitorReport = monitorReport;
exports.addThirdAnalysisCode = addThirdAnalysisCode;
exports.regReport = regReport;
exports.actReport = actReport;
exports.getGAId = getGAId;

var WEB_SITE_REGEX = /(futunn|futu5|moomoo|fututrade|futuniuniu|futuhn|futuhk)/i;
// google 上报代码对应的域名id
var GOOGLE_ANALYSIS_IDS = {
    'futunn': {
        ga: 'GTM-NCRXC5D',
        gtag: 'UA-71722593-3'
    },
    'futu5': {
        ga: 'GTM-P4RNRX',
        gtag: 'UA-71722593-2'
    },
    // futuhk同futu5
    'futuhk': {
        ga: 'GTM-P4RNRX',
        gtag: 'UA-71722593-2'
    },
    'moomoo': {
        ga: 'GTM-WX6RFXT',
        gtag: 'UA-137699611-1'
    },
    // leeliao 说fututrade共用moomoo的id
    'fututrade': {
        ga: 'GTM-WX6RFXT',
        gtag: 'UA-137699611-1'
    },
    // futuniuniu和futuhn不需要gtag
    'futuniuniu': {
        ga: 'GTM-MJ7P8TG'
    },
    'futuhn': {
        ga: 'GTM-WGF6SNJ'
    }
};
var FACEBOOK_PIXEL_IDS = {
    'moomoo': '331134971153078',
    'fututrade': '331134971153078',
    'futunn': '2101647043406453',
    'futu5': '2101647043406453'
};
/**
 * 初始化上报内容/包括 初始化前端dedog上报、点击事件上报监听（可选
 * @param  {object} [config] 上报的配置项
 * @param {string|number} [config.uid=0] 牛牛号
 * @param {string} [config.open_id] 第三方账号的open_id
 * @param {boolean} [config.needStat=true] 是否需要点击事件上报 为true的话，会添加事件点击上报监听事件
 * @return {void}
 *
 * @example
 *
Report.initReport({
    needStat: true, // 需要点击上报事件，默认为true
    uid: 600019, // 牛牛号，有的话，需要填
    open_id: 12243, // 第三方账号的open_id,可选
});
// 需要添加点击事件上报的元素需是可点击元素，需要加上j_stat_btn，点击上报id放在data-eventId属性中
// <a href="javascript:void(0);" class="j_stat_btn" data-eventId="123456">登录</a>
 */
function initReport(config) {
    config = BASE.extend({
        needStat: true,
        uid: 0
    }, config);
    // 初始化前端dedog上报
    initDedog({
        uid: config.uid
    });

    if (config.needStat) {
        // 对按钮做事件上报
        BASE.delegateEvent(BASE.$('body'), '.j_stat_btn', 'click', function () {
            // eslint-disable-next-line no-invalid-this
            var event_id = this.getAttribute('data-eventId');

            upLoadStat({
                event_id: event_id,
                uid: config.uid
            });
        });
    }
}
/**
 * 异步添加第三方统计代码（google、facebook、yahoo）
 * @param {object} config 参数
 * @param {boolean} config.googleAnalysis 是否需要植入google ga gtm 统计代码，目前只支持站点主域为futunn、futu5、moomoo 的
 * @param {boolean} config.facebookPixel 是否需要植入facebook pixel 统计代码
 * @param {booleab} config.yahooPixel 是否需要植入yohoo pixel 统计代码
 * @return {void}
 * @author cynthia
 * @since 1.9.0
 * @example
 * Report.addThirdAnalysisCode({
 *     googleAnalysis : true,
 *     facebookPixel : true,
 *     yahooPixel : true
 * });
 */
function addThirdAnalysisCode(config) {
    config = BASE.extend({
        googleAnalysis: false,
        facebookPixel: false,
        yahooPixel: false
    }, config);
    // 第三方统计代码
    if (config.googleAnalysis || config.facebookPixel || config.yahooPixel) {
        var statOpts = {
            // 是否需要facebook代码上报，true时会自动异步初始化facebook pixel代码统计，如不填写则不进行初始化(v1.3.0)
            facebookPixel: config.facebookPixel,
            // 是否需要yahoo代码上报，true时会自动异步初始化yahoo pixel代码统计，如不填写则不进行初始化(v1.3.0)
            yahooPixel: config.yahooPixel
        };
        var matchWebSite = window.location.origin.match(WEB_SITE_REGEX);
        var webSite = matchWebSite ? matchWebSite[0].toLocaleLowerCase() : '';
        if (config.googleAnalysis) {
            var gaId = GOOGLE_ANALYSIS_IDS[webSite];
            if (!gaId) {
                console.warn('business-act report addThirdAnalysisCode ：本组件暂未收录目前站点主域对应的google ga 和 gtag id，不能植入google上报代码');
            } else {
                BASE.extend(statOpts, gaId);
            }
        }
        if (config.facebookPixel) {
            var facebookPixel = FACEBOOK_PIXEL_IDS[webSite];
            if (!facebookPixel) {
                console.warn('business-act report addThirdAnalysisCode ：本组件暂未收录目前站点主域对应的facebook pixel id，不能植入facebook pixel上报代码');
            } else {
                statOpts.facebookPixel = facebookPixel;
            }
        }
        new Stat(statOpts);
    }
}

/**
 * 获取当前域名的GAId
 * @return {object} 返回对应域名的gaid
 */
function getGAId() {
    var matchWebSite = window.location.origin.match(WEB_SITE_REGEX);
    var webSite = matchWebSite ? matchWebSite[0].toLocaleLowerCase() : '';
    return GOOGLE_ANALYSIS_IDS[webSite] || {};
}

/**
 * 点击上报事件
 * @static
 * @param {Object} opts 上报参数
 * @param  {String} opts.event_id 事件id
 * @param {string} opts.uid 牛牛号
 * @param {string} opts.ext1 ext1-ext4扩展字段非必选
 * @return {void}
 * @example
 Report.upLoadStat({
    event_id: '123456',
    uid:'600019',
    ext1: '123',//扩展字段1 ,非必选
 });
 */
function upLoadStat(opts) {
    opts = BASE.extend({
        client_time: Date.now() / 1000 >> 0 + '',
        client_ver: '0',
        report_id: '4',
        uid: 0
    }, opts);
    new Stat().uploadServer(opts, function (err, data) {});
}

/**
 * 对tool-dedog的setOptions进行再封装，先做了dedog是否存在的判断
 * @static
 * @param  {Object} opts [参数同tool-dedog的setOptions参数]
 * @return {void}
 * @example
 Report.initDedog({uid:600019});
 */
function initDedog(opts) {
    window['dedog'] && window['dedog'].setOptions(opts);
}
/**
 * 前端上报打log
 * @static
 * @param  {*} message  [log内容]
 * @param  {String|null} logLevel [log级别，默认为info, 有5个级别：'error','warning','notice','info','debug']
 * @return {void}
 *
 * @example
Report.log('初始化话页面');
Report.log({
    msg: '初始化页面',
    uid: 600019
});
Report.log('出错了', 'error');
 */
function log(message, logLevel) {
    window['dedog'] && window['dedog'].log({
        //必填。这里是5个级别：'error','warning','notice','info','debug',对应uls查询列表中LogLevel那一列
        level: logLevel || 'info',
        message: (0, _stringify2.default)(message)
    });
}
/**
 * [前端上报-monitor上报]
 * @param  {string|number} monitorId 要上报到的monitorId
 * @param  {number} counts=1 累积量，可不传，默认为1
 * @return {void}
 */
function monitorReport(monitorId, counts) {
    window['dedog'] && window['dedog'].monitorReport(monitorId, counts);
}
/**
 * 注册数据上报
 * @public
 * @static
 * @since 1.10.0
 * @param {Object} opts [上报数据]
 * @returns {void}
 * @example
 * var JSEncrypt = require('@futuweb/business-act/es5/JSEncrypt.es5.js');
 * // JSEncrypt是通过aes做的非对称加密，内部已做封装，专门用于此处对手机号加密
 * Report.regReport({
 *    // 活动测种在cookie中的值，在注册侧获取
 *    session_id: 'x39485023452',
 *    // 注册用的手机号，需要做一层加密
 *    phone: JSEncrypt.getEncryptData('13189775053'),
 *    uid: 1000001,
 *    // 注册1，登录2，活动3，安全中心4，自选股5
 *    page_type:'1',
 *    // 1. "点击图片验证码验证成功" 2. "点击短信验证" 3. "点击提交验证码" 4. "点击输入密码"
 *    click_button: '1',
 *    JSEncrypt: JSEncrypt,
 *    passport: '123456',
 *    user_input: {
 *        "username" : {
 *        "textIsCopy" : "false", //是否复制字符
 *        "textIsTap" : "true",//是否点击了编辑框
 *        "textClickTime" : 1191,//点击时间
 *        "mouseScreenPosition" : "76:65",//鼠标最后位置；触摸最后位置
 *        "textKeyCount" : 7//输入字符个数
 *      }
 *    }
 * });
 */
function regReport(opts) {
    var JSEncrypt = opts.JSEncrypt;
    if (!key) {
        key = JSEncrypt.randomKey();
    }
    var rsaKey = JSEncrypt.getEncryptData(key);

    var option = BASE.extend({
        session_id: '',
        phone: '',
        uid: '0',
        // 注册1，登录2，活动3，安全中心4，自选股5
        page_type: '1',
        load_time: loadPageTime,
        // 1. "点击图片验证码验证成功" 2. "点击短信验证" 3. "点击提交验证码" 4. "点击输入密码" 5. 注册成功
        click_button: '',
        // 上报的公共字段
        client_time: Date.now() / 1000 >> 0 + '',
        client_ver: '0',
        report_id: '26',
        enc_key: rsaKey,
        passport: '',
        user_input: ''
    }, opts);

    _promise2.default.all([Env.getEnv(), Env.getWebrtcDefer()]).then(function (_ref) {
        var _ref2 = (0, _slicedToArray3.default)(_ref, 2),
            env = _ref2[0],
            fp_webrtc = _ref2[1];

        env.fp_webrtc = fp_webrtc;
        return _promise2.default.resolve(env);
    }).then(function (info) {
        info.pass_hash = option.passport ? JSEncrypt.shaPwd(option.passport) : '';
        info.user_input = option.user_input;
        var aesData = JSEncrypt.encrypt((0, _stringify2.default)(info), key);
        option.rich_info = aesData;
        option.user_name = option.uid;

        if (/^[0-9]+$/.test(option.phone)) {
            //传过来的phone未进行加密
            option.phone = JSEncrypt.getEncryptData(option.phone);
        }

        //移除passport属性
        delete option.passport;
        //uid字段修改为user_name
        delete option.uid;
        delete option.JSEncrypt;
        new Stat().uploadServer(option, function (err, data) {});
    });
}

/**
 * 活动数据上报
 * @public
 * @static
 * @since 1.10.0
 * @param {Object} opts [上报数据]
 * @returns {void}
 * @example
 * Report.regReport({
 *    // 活动测种在cookie中的值，在注册侧获取
 *    session_id:'x39485023452',
 *    uid: '0',
 *    // 页面类型： 运营活动
 *    page_type: '1',
 *    // 活动侧，click_button为对应的eventid
 *    click_button: '500625',
 *    // user_type 用户类别：团长、团员
 *    user_type: '',
 *    JSEncrypt: JSEncrypt,
 *    passport: '123456',
 * });
 */
function actReport(opts) {
    var JSEncrypt = opts.JSEncrypt;
    if (!key) {
        key = JSEncrypt.randomKey();
    }

    var rsaKey = JSEncrypt.getEncryptData(key);

    var option = BASE.extend({
        session_id: '',
        uid: '0',
        page_type: '1',
        load_time: loadPageTime,
        click_button: '',
        user_type: '',

        // 上报的公共字段
        client_time: Date.now() / 1000 >> 0 + '',
        client_ver: '0',
        report_id: '27',
        enc_key: rsaKey,
        passport: ''
    }, opts);

    _promise2.default.all([Env.getEnv(), Env.getWebrtcDefer()]).then(function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            env = _ref4[0],
            fp_webrtc = _ref4[1];

        env.fp_webrtc = fp_webrtc;
        return _promise2.default.resolve(env);
    }).then(function (info) {
        info.pass_hash = option.passport ? JSEncrypt.shaPwd(option.passport) : '';
        var aesData = JSEncrypt.encrypt((0, _stringify2.default)(info), key);
        option.rich_info = aesData;
        option.user_name = option.uid;
        //移除passport属性
        delete option.passport;
        //uid字段修改为user_name
        delete option.uid;
        delete option.JSEncrypt;
        new Stat().uploadServer(option, function (err, data) {});
    });
}